export default __webpack_public_path__ + "static/media/lc-m.af699308.webp";